import React, { useState, useEffect } from 'react'
import { node } from 'prop-types'
import { useAuth0 } from '@auth0/auth0-react'
import axiosInstance from 'api/axiosInstance';

// eslint-disable-next-line
const AuthRoutine = ({ children }) => {
  const { loginWithRedirect, isAuthenticated, isLoading, getAccessTokenSilently, user } = useAuth0()
  const [isAccessTokenSetup, setIsAccessTokenSetup] = useState(false)
  const accessRestrictedRoles = process.env.REACT_APP_ENABLED_USER_ROLES?.split(',') || ['heuritech']
  const userRoles = (user && user['heuritech.roles']) || []

  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      loginWithRedirect({ appState: { returnTo: window.location.href } })
    }
  }, [isAuthenticated, isLoading])

  useEffect(() => {
    if (isAuthenticated) {
      axiosInstance.interceptors.request.use(async (request) => {
        const token = await getAccessTokenSilently()
        return {
          ...request,
          headers: {
            ...(request.headers || {}),
            Authorization: `Bearer ${token}`,
          },
        }
      })

      setIsAccessTokenSetup(true)
    }
  }, [isAuthenticated])

  if (!isAccessTokenSetup) return <div>Waiting for authentication ...</div>

  if (!accessRestrictedRoles.some((role) => userRoles.includes(role))) {
    return <div>OOPS! You do not have permission to access this app.</div>
  }

  return children
}

AuthRoutine.propTypes = {
  children: node.isRequired,
}

export default AuthRoutine
